import { drmExpireTableData } from "../../service/drmExpireTableData";
import {
  setExpireDrmTableDataSuccess,
  setExpireDrmTableDataFailure,
} from "../reducers/drmExpireTableDataSlice";
import { buildRecordOperationMessage } from "./drmOperationMessage";

import { put, takeLatest, call } from "redux-saga/effects";

export function* workerExpireDrmTableData(action) {
  const { payload } = action;

  try {
    const response = yield call(drmExpireTableData, [
      payload.userCode,
      payload.submitDetails,
      payload.tableName,
      payload.controller,
    ]);

    const combinedPayload = buildRecordOperationMessage(response, {
      failureLabel: "Failed expirations",
      successLabel: "Successful expirations",
    });

    yield put(setExpireDrmTableDataSuccess(combinedPayload));
  } catch (error) {
    yield put(setExpireDrmTableDataFailure(error.toString()));
  }
}

function* drmExpireTableDataSaga() {
  yield takeLatest(
    "expireDrmtTableData/setExpireDrmTableData",
    workerExpireDrmTableData
  );
}

export default drmExpireTableDataSaga;
